var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header",attrs:{"id":"header"}},[(_vm.isBeforeConnect)?_c('before-page-header'):_c('connect-header')],1)}
var staticRenderFns = []

export { render, staticRenderFns }